import React from 'react';
var CaretDown = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 30 30" },
        React.createElement("polygon", { fill: fill, points: "26.096481 5.55 30 9.45351896 15 24.453519 0 9.45351896 3.90351896 5.55 15 16.6465687" })));
};
export default CaretDown;
